// extracted by mini-css-extract-plugin
export default {"spinHolder":"styles_spinHolder__lRv3u"};